import { Injectable } from '@angular/core';
import {
  HttpResponse
} from '@angular/common/http';
import { BackendService } from './backend.service';
import { ActionsService } from './actions.service';
import { SvcServices } from './svc.service';
import { PopupModalService } from './popup-modal.service';
import { Observable, from } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MFACallback, MFAResponse, MFAActionType } from '../models';
import { ContentService } from './content.service';


@Injectable({
  providedIn: 'root'
})
export class MFAService {

  constructor(private actions: ActionsService,
    private backend: BackendService,
    private popupModalService: PopupModalService,
    private _svcService: SvcServices, private contentService: ContentService) { }

  data: any;
  endpoint: string;
  httpMethod: string;
  level: number;
  pathParams: string;
  appVersionValue: any;
  header: any;
  tmxEncryptionEnabled: any;
  mfaSuccessCallbackCount: number = 0;
  isFuipFlow: boolean = false;
  mfaSuccessCallbackMsgList: string[] = [];
  

  /**
   * 
   * MFA interdict method which will invoke the hrt call
   * 
   * @param endpoint - backend api url to be triggered
   * @param method - http method
   * @param data - input data to be sent to api 
   * @param callBack - callback to be triggered after mfa success
   * @param level - level of the HRT
   * 
   * Below are possible outcomes when interdict method is invoked.
   * 
   * 1. If MFA returns "ALLOW" ---> we don't need to interdict the user, so just invoke call back with 'MFAActionType.ALLOW' and response received
   * 2. If MFA returns "DENY" -->  we should block the user from completing the transaction. Call back invoked with 'MFAActionType.DENY', assumtpion is
   *     the calling component will take of next action like show takeover or force logout the user
   * 3. If MFA returns "CHALLENGE", interdict the user with challenge type returned. 
   *    3.1. If user completed intediction successfully, invoke the endpoint again and then call back with 'MFAActionType.CHALLENGE_SUCCESS' and api response.
   *    3.2. If user answered question incorrectlly more than 3 times, user will logged out and user account will be locked for 24 hrours.
   * 
   */
  public interdict(endpoint: string, httpMethod: string, data: any, callBack: MFACallback, level: number, pathParams?: any) {
    if (!httpMethod) {
      httpMethod = "post";
    }
    this.data = data;
    this.endpoint = endpoint;
    this.httpMethod = httpMethod;
    this.level = level;
    this.pathParams = pathParams;
    this.appVersionValue;


    try {
      this.contentService.getConfigContent()
        .pipe(catchError(this.appVersionErrorHandler))
        .subscribe((response) => {
          this.appVersionMethod(response);
          this.invokeInterdict(httpMethod, callBack);
        });
    }
    catch (e) { }

  }


  public interdictwithHeader(endpoint: string, httpMethod: string, data: any, callBack: MFACallback, level: number, header?: any, pathParams?: any, tmxEncryptionEnabled?: any) {
    if (!httpMethod) {
      httpMethod = "post";
    }
    this.data = data;
    this.endpoint = endpoint;
    this.httpMethod = httpMethod;
    this.level = level;
    this.pathParams = pathParams;
    this.appVersionValue;
    this.header = header;
    this.tmxEncryptionEnabled= tmxEncryptionEnabled;
    
    this.invokeInterdictWithTMXflag(httpMethod, callBack);

  }

  public interdictFuip(endpoint: string, httpMethod: string, data: any, callBack: MFACallback, level: number, header: any, pathParams?: any, mfaSuccessCallbackMsgList?: string[]) {
    if (!httpMethod) {
      httpMethod = "post";
    }
    this.data = data;
    this.endpoint = endpoint;
    this.httpMethod = httpMethod;
    this.level = level;
    this.pathParams = pathParams;
    this.mfaSuccessCallbackMsgList = mfaSuccessCallbackMsgList;
    this.appVersionValue;
    this.header = header;
    this.isFuipFlow = true;

    this.invokeInterdict(httpMethod, callBack);

  }



  public interdictFuipwithReg(endpoint: string, httpMethod: string, data: any, callBack: MFACallback, level: number, header: any, pathParams?: any, tmxEncryptionEnabled?: any) {
    if (!httpMethod) {
      httpMethod = "post";
    }
    this.data = data;
    this.endpoint = endpoint;
    this.httpMethod = httpMethod;
    this.level = level;
    this.pathParams = pathParams;
    this.appVersionValue;
    this.header = header;
    this.tmxEncryptionEnabled= tmxEncryptionEnabled;
    this.isFuipFlow = true;

    this.invokeInterdictwithReg(httpMethod, callBack);

  }

  invokeInterdict(httpMethod: string, callBack: MFACallback) {
    switch (httpMethod) {
      case "post":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .post(this.endpoint, this.data, this.header, this.pathParams)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);

            if(this.isFuipFlow) {
              this._svcService.invokeGlobalData();
            }

            this.mfaResponseHandler(response, callBack);
          });
        break;
      case "put":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .put(this.endpoint, this.data, this.header)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);
            this.mfaResponseHandler(response, callBack);
          });
        break;
    }
  }


  invokeInterdictwithReg(httpMethod: string, callBack: MFACallback) {
    switch (httpMethod) {
      case "post":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .post(this.endpoint, this.data, this.header, this.pathParams)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);
            this.mfaResponseHandler(response, callBack);
          });
        break;
      case "put":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .put(this.endpoint, this.data, this.header)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);
            this.mfaResponseHandler(response, callBack);
          });
        break;
    }
  }

  invokeInterdictWithTMXflag(httpMethod: string, callBack: MFACallback) {
    switch (httpMethod) {
      case "post":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .post(this.endpoint, this.data, this.header, this.pathParams, this.tmxEncryptionEnabled)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);

            if(this.isFuipFlow) {
              this._svcService.invokeGlobalData();
            }

            this.mfaResponseHandler(response, callBack);
          });
        break;
      case "put":
        this._svcService.componentLoaded.emit(false);
        this.backend
          .put(this.endpoint, this.data, this.header)
          .pipe(catchError(this.mfaErrorHandler))
          .subscribe(response => {
            this._svcService.componentLoaded.emit(true);
            this.mfaResponseHandler(response, callBack);
          });
        break;
    }
  }

  appVersionMethod(response: any) {
    if (response && response.appVersion) {
      this.header = {
        "appVersion": response.appVersion
      }
    } else if (response && response.content && response.content.CARDS && response.content.CARDS.config$$cfg_svc_app_registration) {
      this.appVersionValue = response.content.CARDS.config$$cfg_svc_app_registration.appVersion ? response.content.CARDS.config$$cfg_svc_app_registration.appVersion : '';

      this.header = {
        "appVersion": this.appVersionValue
      }
    }
  }

  appVersionErrorHandler(): Observable<{ appVersion: string }> {
    return from([{ appVersion: 'FSVC-NGA-2021-06-00' }]);
  }

  mfaResponseHandler(response, callBack: MFACallback) {
    let mfaResponse: MFAResponse;
    console.log("MFAResposne::::",response);
    if (response.error && 
        response.error.headers && 
        response.error.headers.get("challengetype") === "[LTD_NOSQ]") {
        console.log("MFAResposne 403 sec auth check LTD NOSQ");
        mfaResponse = {
          mfaActionType: MFAActionType.ALLOW,
          response: response
        }
        callBack(mfaResponse);
    }
    if (response.error) {
      if (response.error.interdict) {
        this.challengeUser(response.error, callBack);
      } else if (response.error.deny) {
        mfaResponse = {
          mfaActionType: MFAActionType.DENY,
          response: response
        }
        callBack(mfaResponse);
      } else if (response.error.devdeny) {
        mfaResponse = {
          mfaActionType: MFAActionType.DEVDENY,
          response: response
        }
        callBack(mfaResponse);
      } else if (response.error.collect) {
        mfaResponse = {
          mfaActionType: MFAActionType.COLLECT,
          response: response
        }
        callBack(mfaResponse);
      } else if (response.error.headers.get("action") === "ALLOW") {
        mfaResponse = {
          mfaActionType: MFAActionType.ALLOW,
          response: response
        }
        callBack(mfaResponse);
      } else {
        mfaResponse = {
          mfaActionType: MFAActionType.CHALLENGE_FAILURE,
          response: response
        }
        callBack(mfaResponse);
      }
    }
    else {
      if (response.headers.get("action") === "ALLOW") {
        mfaResponse = {
          mfaActionType: MFAActionType.ALLOW,
          response: response
        }
        callBack(mfaResponse);
      } else {
        mfaResponse = {
          mfaActionType: MFAActionType.CHALLENGE_FAILURE,
          response: response
        }
        callBack(mfaResponse);
      }
    }
  }

  /**
   * 
   * @param error 
   * 
   * MFA response error handler which interpret the response and determines mfa actions to be executed from UI
   * 
   */
  mfaErrorHandler(response): Observable<{ error: string }> {
    console.log("DEBUG mfaErrorHandler - status:", response.status);
    console.log("DEBUG mfaErrorHandler - action header:", response.headers.get("action"));
    console.log("DEBUG mfaErrorHandler - challengeType header:", response.headers.get("challengeType"));
    console.log("DEBUG mfaErrorHandler - all header keys:", response.headers.keys());
    if (response.status === 403) {
      if (response.headers.get("action") === "CHALLENGE") {
        if(response.headers.get("challengeType") === "[COLLECT]") {
          response.collect = true;
        } else {
          response.interdict = true;
        }
        
      } else if (response.headers.get("action") === "DENY") {
        response.deny = true;
      }
      else if (response.headers.get("action") === "DEVDENY") {
        response.devdeny = true;
      }
    }
    return from([{ error: response }]);
  }


  /**
   * 
   * @param error 
   * 
   * MFA response error handler which interpret the response and determines mfa actions to be executed from UI
   * 
   */
  errorHandler(response): Observable<{ error: string }> {
    return from([{ error: response }]);
  }


  getMFAInterdictionType(response: any): any {

    if (response.headers.get("action") === "CHALLENGE") {
      response.interdict = true;
    } else if (response.headers.get("action") === "DENY") {
      response.deny = true;
    }
    else if (response.headers.get("action") === "DEVDENY") {
      response.devdeny = true;
    }
  }

  challengeUser(response: any, mfaCallBack: MFACallback) {
    const hrtModalCallback: any = (mfaPassed: string, mfaResponse: any) => {
      this.mfaServiceCallBack(mfaPassed, mfaResponse, mfaCallBack);
    }
    let result = response.body ? response.body : (this.isFuipFlow ? response.error.mfaAnalyzeResponse : response.error);
    let transmitFlag = false;
    if(result.moreInfo && result.moreInfo != null){
      for (var i = 0; i < result.moreInfo.length; i++) {
        if (result.moreInfo[i].mfaChallengeSource === 'TRANSMIT') {
          transmitFlag = true;
        }
  
      }
    }

    if(this.isFuipFlow && result.mfaChallengeSource) {
      transmitFlag = true;
    }
    
    if (response.headers.get("challengeType") === "[OTP]") {
      this.popupModalService.openMfaModalLibrary.emit({
        mfaModalComponent: {
          popupName: "otp-request",
          popupData: response.body ? response.body : (this.isFuipFlow ? response.error.mfaAnalyzeResponse : response.error),
          callBack: hrtModalCallback,
          hrtLevel: this.level
        }
      });
    } else if (["[QUESTIONS_CVV]", "[QUESTIONS]"].includes(response.headers.get("challengeType"))) {

      if (transmitFlag == true) {
        this.popupModalService.openMfaModalLibrary.emit({
          mfaModalComponent: {
            popupName: "transmit-security-question",
            popupData: response.body ? response.body : (this.isFuipFlow ? response.error.mfaAnalyzeResponse : response.error),
            callBack: hrtModalCallback,
            hrtLevel: this.level,
            challengeType: response.headers.get("challengeType")
          }
        });
      } else {
        this.popupModalService.openMfaModalLibrary.emit({
          mfaModalComponent: {
            popupName: "security-question",
            popupData: response.body ? response.body : (this.isFuipFlow ? response.error.mfaAnalyzeResponse : response.error),
            callBack: hrtModalCallback,
            hrtLevel: this.level,
            challengeType: response.headers.get("challengeType")
          }
        });
      }
    }
    else if (this.level === 2) {
      try {
        let challengeList = response.headers.get("challengeType");
        let challengeListArr = challengeList.replace(/[\[\s\]]/g, "").split(","); // Remove whitespace and brackets, split by ','.
        if (challengeListArr[0] === "OTP") {
          this.popupModalService.openMfaModalLibrary.emit({
            mfaModalComponent: {
              popupName: "otp-request",
              popupData: response.body ? response.body : response.error,
              callBack: hrtModalCallback,
              hrtLevel: this.level,
              fallbackChallengeType: "[" + challengeListArr[1] + "]"
            }
          });
        }
        else { // challengeListArr[0] will be either "QUESTIONS" or "QUESTIONS_CVV"

          if (transmitFlag == true) {
            this.popupModalService.openMfaModalLibrary.emit({
              mfaModalComponent: {
                popupName: "transmit-security-question",
                popupData: response.body ? response.body : response.error,
                callBack: hrtModalCallback,
                hrtLevel: this.level,
                challengeType: "[" + challengeListArr[0] + "]"
              }
            });
          } else {
            this.popupModalService.openMfaModalLibrary.emit({
              mfaModalComponent: {
                popupName: "security-question",
                popupData: response.body ? response.body : response.error,
                callBack: hrtModalCallback,
                hrtLevel: this.level,
                challengeType: "[" + challengeListArr[0] + "]"
              }
            });
          }

        }
      }
      catch (e) {
        // Problem reading challenge type
      }
    }
  }


  mfaServiceCallBack(mfaPassed: string, response: any, mfaCallBack: MFACallback) {
    if ('DENY' === response) {
      let mfaResponse: MFAResponse = {
        mfaActionType: MFAActionType.DENY,
        challengeType: null,
        response: null
      };
      mfaCallBack(mfaResponse);
    }
    else if ('DEVDENY' === response) {
      let mfaResponse: MFAResponse = {
        mfaActionType: MFAActionType.DEVDENY,
        challengeType: null,
        response: null
      };
      mfaCallBack(mfaResponse);
    }
    else if ('CANCEL' === response) {
      let mfaResponse: MFAResponse = {
        mfaActionType: MFAActionType.CANCEL,
        response: 'CANCEL'
      }
      mfaCallBack(mfaResponse);
    } else {
      if ('MFA_LOCKOUT' === mfaPassed) {
        sessionStorage.setItem('mfaLockoutSignoff', 'true');
        window.location.href = response;
        return false;
      }

      if(this.mfaSuccessCallbackMsgList && this.mfaSuccessCallbackMsgList.length > 0 && this.mfaSuccessCallbackCount < this.mfaSuccessCallbackMsgList.length){
        let mfaSuccessHeader = this.mfaSuccessCallbackMsgList[this.mfaSuccessCallbackCount++];
        this.header["challengeStatus"] = mfaSuccessHeader;
      }

      switch (this.httpMethod) {
        case "post":
          this._svcService.componentLoaded.emit(false);
          this.backend
            .post(this.endpoint, this.data, this.header || null, this.pathParams || null)
            .pipe(catchError(this.mfaErrorHandler))
            .subscribe(response => {
              this._svcService.componentLoaded.emit(true);
              let mfaResponse: MFAResponse = {
                mfaActionType: MFAActionType.CHALLENGE_SUCCESS,
                response: response
              }
              mfaCallBack(mfaResponse);

            });
          break;
        case "put":
          this._svcService.componentLoaded.emit(false);
          this.backend
            .put(this.endpoint, this.data, null)
            .pipe(catchError(this.mfaErrorHandler))
            .subscribe(response => {
              this._svcService.componentLoaded.emit(true);
              let mfaResponse: MFAResponse = {
                mfaActionType: MFAActionType.CHALLENGE_SUCCESS,
                response: response
              }
              mfaCallBack(mfaResponse);
            });
          break;
      }
    }
  }
}
